module.exports = __webpack_public_path__ + "img/12_broadway_market_new.806924fd.jpg";